<template>
  <div class="insights">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'Insights',
};
</script>
